/**
 * Developer: Stepan Burguchev
 * Date: 10/10/2014
 * Copyright: 2009-2016 Comindware®
 *       All Rights Reserved
 * Published under the MIT license
 */

'use strict';

export default /** @lends module:core.utils.keyCode */ {
    BACKSPACE: 8,
    COMMA: 188,
    DELETE: 46,
    DOWN: 40,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    HOME: 36,
    LEFT: 37,
    NUMPAD_ADD: 107,
    NUMPAD_DECIMAL: 110,
    NUMPAD_DIVIDE: 111,
    NUMPAD_ENTER: 108,
    NUMPAD_MULTIPLY: 106,
    NUMPAD_SUBTRACT: 109,
    NUMPAD_0: 96,
    NUMPAD_9: 105,
    NUM_0: 48,
    NUM_9: 57,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    PERIOD: 190,
    RIGHT: 39,
    SPACE: 32,
    TAB: 9,
    UP: 38,
    CTRL: 17,
    ALT: 18,
    ADD: 187,
    SUBTRACT: 189,
    SLASH: 191,
    E: 69
};



// WEBPACK FOOTER //
// ../src/utils/keyCode.js